
import { Component, Prop, VModel, Watch } from "vue-property-decorator";
import Vue from "vue";
import { formatDateTime } from "../../services/base-service";

@Component({
  methods: {
    formatDateTime,
  },
})
export default class PazDateField extends Vue {
  @VModel()
  public date: any;

  public textDate = null;

  @Prop() public editable!: boolean;

  @Prop({ default: "date" })
  public label!: string;

  @Prop({ default: false })
  public closeOnclick?: boolean;

  @Prop()
  public formatDateString?: string;

  public menu: boolean = false;
  public activePicker: string = "DATE";

  @Watch("date")
  onSetDate(date: string | null) {
    if (!this.formatDateString) this.textDate = date;
    else {
      this.textDate = formatDateTime(date, undefined, this.formatDateString);
    }
  }
}
